import React from 'react'
import CreateResellersContainer from 'containers/panel/admin/create-resellers-container'

const AdminResellersCreatePage = () => {
  return (
    <CreateResellersContainer/>
  )
}

export default AdminResellersCreatePage